<template>
  <div class="card-body p-3">
    <div class="float-right mr-n2">
      <label class="custom-control custom-checkbox">
        <input
            type="radio"
            class="custom-control-input"
            name="flexRadioDefault"
            @change="check($event)"
            :value="JSON.stringify(state)"
        >
        <span class="custom-control-label"></span>
      </label>
    </div>
    <div>
      <p class="mb-3">
        <span v-if="roles.includes('ROLE_ADMIN')" class="text-success">
          <i class="fa fa-map-marker mr-3" aria-hidden="true"></i>{{ state.pointVente }}
        </span> <br>
        <i class="fa fa-clock-o mr-2" aria-hidden="true"></i>&nbsp;<b>{{ state.createdAt | hourFormat }}</b><br>
        <i class="fa fa-hourglass-start mr-2" aria-hidden="true"></i>&nbsp;{{ state.createdAt | interval }}<br>
        <i class="fa fa-shopping-basket mr-1" aria-hidden="true"></i>&nbsp;Commande <b>{{ state.id }}</b><br>
        <i class="fa fa-user mr-2" aria-hidden="true"></i>&nbsp;Client {{ state.client.firstname }} {{ state.client.lastname }} <br>
        <i class="fa fa-phone" aria-hidden="true"></i>&nbsp;{{ state.client.phone }}
      </p>
    </div>

    <!-- Client info -->
    <div class="float-right mt-1">          
      <b-avatar button class="mx-2" variant="success" icon="chat-right-text" v-b-modal="'comment-modal' + state.id"></b-avatar>
      <b-modal :id="'comment-modal' + state.id" hide-footer>
        <!-- { "message": "this.comment", "author": "Author 1", "createdAt": "2019-08-24T14:15:22+00:00" } -->
        <div class="m-auto" style="min-height: 100px; overflow-y: scroll; overflow-x: hidden;">
          <div class="row mt-2" v-for="(comment) in state.commentsOrder" :key="comment.id">
            <div class="col-md-2 text-end">
              <b-avatar variant="info" src="https://placekitten.com/300/300" size="3rem"></b-avatar>
            </div>
            <div class="col-md-10 px-3">
              <div class="row mb-1">
                <div class="col-md-6 text-start pl-0">
                  {{  comment.author  }}
                </div>
                <div class="col-md-6 text-end">
                  <small class="text-muted">{{ comment.createdAt | interval }}</small>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 comment-background p-2 m-0">
                  {{ comment.message }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <textarea-field
            class="mt-4"
            name="Commentaire"
            property="info"
            v-model="comment"
            length="100"
        />
        <button type="button" class="btn btn-primary btn-sm float-right" @click="newComment(state.id)">Ajouter</button>
      </b-modal>
    
    </div>
    <!-- Collapse order details -->
    <a class="btn btn-outline-primary btn-sm my-2" style="cursor: pointer" v-b-toggle="'order-collapse' + state.id">Détails</a>
    <b-collapse :id="'order-collapse' + state.id">
      <ul class="list-group list-group-numbered">
        <li v-for="item in state.orderItems" :key="item.id"
            class="list-group-item d-flex justify-content-between align-items-start">
          <div class="ms-2 me-auto">
            <div class="fw-bold">
              {{ item.name }}
              <span class="badge bg-primary rounded-pill">x {{ item.qty }}</span>
            </div>
            <!--                            <i class="text-lowercase small">{{ item.category }}</i>-->
          </div>
          <div class=" me-auto" v-if="item.category === 'menu'">
            <ul style="padding-left: 1rem;">
              <li class="small" v-for="product in item.products" :key="product.name">
                <b>{{ product.name }}</b>&nbsp;
                <span class="badge bg-primary rounded-pill">x {{ product.qty }}</span> <br>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </b-collapse>
  </div>
</template>

<script>
import { TextareaField } from "@/core/components/form";
import moment from 'moment';
import { mapState, mapActions } from 'vuex';
export default {
  name: 'CardKanban',
  props:{ state: {}, roles: {}, name: {} },
  components:{
    TextareaField
  },
  data(){
    return {
      input:[],
      comment: ''
    }
  },
  computed:{
    ...mapState('auth',['fullUser']),
    ...mapState('orders',['apiRslt'])
  },
  methods:{
    ...mapActions('orders',['addComment']),
    check(e){
      this.$emit('input',e.target.value)
    },
    newComment(idOrder){
      this.addComment({list: this.name, id: idOrder, obj:{
        message: this.comment,
        author: this.fullUser.username,
        createdAt: moment().format(),
        orderOrigin: '/api/orders/' + idOrder
      }})
      this.comment = ''
    }
  }
}
</script>

<style scoped>
.comment-background{
  background-color: #E9E9E9
}
</style>
